// Catálogo MOCK de planes de crédito — transcrito del mockup (`surekeep/mockups/_shared/mock-data.js`,
// `creditPlans`). Es el FALLBACK de la tab Estándar cuando `GET /credit-plans` falla, nunca el
// camino feliz. Las Políticas Especiales ya no tienen mock: leen `/store-policies`.
import { SaleTypeEnum } from '@fiado/type-kit/bin/loanOfferings/enums/SaleTypeEnum';
import type { CreditPlan } from './types';

export const CREDIT_PLANS: CreditPlan[] = [
    {
        planId: 'mock-bronce',
        tier: 'bronce',
        sciMin: 21,
        sciMax: 60,
        tna: 2.6,
        ivaOnInterest: 0.16,
        downMinPct: 0.4,
        downMaxPct: 0.9,
        maxAmount: 5000,
        termsWeeks: [8, 12, 16],
        openingFeePct: 0,
        active: true,
        lastModified: '2026-06-15',
        version: 3,
        saleTypes: [SaleTypeEnum.NEW],
        prepaymentMinimum: { mode: 'ANY' },
    },
    {
        planId: 'mock-plata',
        tier: 'plata',
        sciMin: 61,
        sciMax: 80,
        tna: 2.3,
        ivaOnInterest: 0.16,
        downMinPct: 0.25,
        downMaxPct: 0.9,
        maxAmount: 8000,
        termsWeeks: [8, 12, 16, 20],
        openingFeePct: 0,
        active: true,
        lastModified: '2026-06-15',
        version: 3,
        saleTypes: [SaleTypeEnum.NEW],
        prepaymentMinimum: { mode: 'ANY' },
    },
    {
        planId: 'mock-oro',
        tier: 'oro',
        sciMin: 81,
        sciMax: 100,
        tna: 2.0,
        ivaOnInterest: 0.16,
        downMinPct: 0.2,
        downMaxPct: 0.9,
        maxAmount: 10000,
        termsWeeks: [8, 12, 16, 20, 24],
        openingFeePct: 0,
        active: true,
        lastModified: '2026-06-15',
        version: 3,
        saleTypes: [SaleTypeEnum.NEW],
        prepaymentMinimum: { mode: 'ANY' },
    },
    {
        planId: 'mock-empleado',
        tier: 'empleado',
        sciMin: 0,
        sciMax: 100,
        tna: 1.2,
        ivaOnInterest: 0.16,
        downMinPct: 0.1,
        downMaxPct: 0.9,
        maxAmount: 15000,
        termsWeeks: [8, 12, 16, 20, 24, 32],
        openingFeePct: 0,
        active: true,
        lastModified: '2026-05-02',
        version: 1,
        saleTypes: [SaleTypeEnum.EMPLOYEE],
        prepaymentMinimum: { mode: 'ANY' },
    },
];
